import { CreateUserMissionLevelButton } from './CreateUserMissionLevelButton'
import { withCreateUserMissionLevelButton } from './withCreateUserMissionLevelButton'

const ConnectedCreateUserMissionLevelButton = withCreateUserMissionLevelButton(
  CreateUserMissionLevelButton
)

export { ConnectedCreateUserMissionLevelButton as CreateUserMissionLevelButton }
